<template>
  <div :style="restaurantInfoStyle">
    <div v-if="$mq === 'xs'">
      <v-layout>
        <v-flex>
          <div class="name">{{ config.full_name }}</div>
          <div
            v-if="seo.description"
            class="description"
          >{{ seo.description }}</div>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="restaurantAddress"
        mt-2
      >
        <v-flex>
          <div class="address-title">{{ $t('address') }}</div>
          <div class="description">
            <v-icon
              class="middle"
              size="13"
              :color="theme.toolbar_color"
            >fas fa-map-marker-alt</v-icon>
            {{ restaurantAddress }}
          </div>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="hasSocialMedia"
        mt-2
      >
        <v-flex>
          <div class="follow_us">
            {{ $t('follow_us') }}
            <div class="nutri-grade-scale">
              <v-img
                src="/assets/images/nutri_grade/scale.png"
                height="26"
                width="74"
                class="nutri-grade-img"
              />
            </div>
          </div>
          <a
            v-if="socialUrl.facebook"
            :href="socialUrl.facebook"
            target="_blank"
          >
            <v-icon
              medium
              :color="theme.toolbar_color"
              class="icon"
            >fab fa-facebook-square</v-icon>
          </a>
          <a
            v-if="socialUrl.instagram"
            :href="socialUrl.instagram"
            target="_blank"
          >
            <v-icon
              medium
              :color="theme.toolbar_color"
              class="icon"
            >fab fa-instagram</v-icon>
          </a>
          <a
            v-if="socialUrl.telegram"
            :href="socialUrl.telegram"
            target="_blank"
          >
            <v-icon
              medium
              :color="theme.toolbar_color"
              class="icon"
            >fab fa-telegram-plane</v-icon>
          </a>
        </v-flex>
      </v-layout>
    </div>
    <div v-else>
      <v-layout row>
        <v-flex
          xs12
          sm12
          md12
          lg10
          offset-lg1
          xl8
          offset-xl2
        >
      <v-layout>
        <v-flex
          :xs12="!hasSocialMedia"
          :xs10="hasSocialMedia"
        >
          <div class="name">{{ config.full_name }}</div>
          <div
            v-if="seo.description"
            class="description"
          >{{ seo.description }}</div>
        </v-flex>
        <v-flex
          v-if="hasSocialMedia"
          xs2
          offset-lg2
          offset-xl3
        >
          <div class="follow_us">
            {{ $t('follow_us') }}
            <div class="nutri-grade-scale">
              <v-img
                src="/assets/images/nutri_grade/scale.png"
                height="26"
                width="74"
                class="nutri-grade-img"
              />
            </div>
          </div>
          <a
            v-if="socialUrl.facebook"
            :href="socialUrl.facebook"
            target="_blank"
          >
            <v-icon
              medium
              :color="theme.toolbar_color"
              class="icon"
            >fab fa-facebook-square</v-icon>
          </a>
          <a
            v-if="socialUrl.instagram"
            :href="socialUrl.instagram"
            target="_blank"
          >
            <v-icon
              medium
              :color="theme.toolbar_color"
              class="icon"
            >fab fa-instagram</v-icon>
          </a>
          <a
            v-if="socialUrl.telegram"
            :href="socialUrl.telegram"
            target="_blank"
          >
            <v-icon
              medium
              :color="theme.toolbar_color"
              class="icon"
            >fab fa-telegram-plane</v-icon>
          </a>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="restaurantAddress"
        mt-2
      >
        <v-flex>
          <div class="address-title">{{ $t('address') }}</div>
          <div class="description">
            <v-icon
              class="middle"
              size="13"
              :color="theme.toolbar_color"
            >fas fa-map-marker-alt</v-icon>
            {{ restaurantAddress }}
          </div>
        </v-flex>
      </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'restaurant-info-component',
  computed: {
    ...mapGetters('config', [
      'config', 'theme', 'restaurantAddress', 'seo', 'socialUrl'
    ]),
    restaurantInfoStyle () {
      return {
        marginTop: '10px',
        backgroundColor: this.theme.toolbar_bg_color,
        color: this.theme.toolbar_color,
        padding: '15px'
      }
    },
    hasSocialMedia () {
      return this.socialUrl.facebook || this.socialUrl.instagram || this.socialUrl.telegram
    }
  }
}
</script>

<style scoped>
.middle {
  padding: 2px 4px 2px 2px;
}
.name {
  font-weight: 800;
}
.description {
  font-size: 13px;
  margin-right: 4px;
}
.address-title {
  font-size: 14px;
  font-weight: 800;
}
.follow_us {
  font-size: 14px;
  font-weight: 800;
  position: relative;
}
.nutri-grade-scale {
  position: absolute;
  left: -76px;
  top: 0;
}
.icon {
  margin-top: 3px;
  margin-right: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/RestaurantInfo.vue